var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "modal-dialog modal-lg modal-dialog-centered ep-modal-dialog",
      attrs: { role: "document" }
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c(
          "div",
          { staticClass: "modal-header" },
          [
            _c(
              "div",
              {
                staticClass: "modal-title txt-24 txt-black txt-768-20",
                attrs: { "data-testid": "title" }
              },
              [_vm._v(" " + _vm._s(_vm.title) + " ")]
            ),
            _c(
              "ep-icon-button",
              {
                attrs: { type: "button", "aria-label": "Close" },
                on: { click: _vm.handleCloseButtonClick }
              },
              [_c("delete-icon")],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "modal-body pb-5" }, [_vm._t("default")], 2)
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }